export default __webpack_public_path__ + "static/media/empleado.fc8ff084.png";